import React from 'react';

import { useGetFile } from '@vlabs/api/point-api/client';
import { DownloadIcon } from '@vlabs/icons';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button/IconButton.js';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button/IconButton.js';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import { useDownloadCardFileTranslation } from './i18n';
import type { DownloadFileProps } from './types';

type DownloadFileIconButtonProps = DownloadFileProps & IconButtonProps;

const displayName = 'DownloadFileIconButton';
const testid = buildTestid(displayName);

function DownloadFileIconButton({
  fileId = undefined,
  'data-testid': dataTestId = undefined,
  ...props
}: DownloadFileIconButtonProps): React.JSX.Element | null {
  const { t } = useDownloadCardFileTranslation();

  const getFile = useGetFile(fileId ?? '', undefined, {
    query: { enabled: !!fileId },
  });

  if (!fileId) return null;

  return (
    <IconButton
      as="a"
      disabled={!getFile.isFetched}
      download={getFile.data?.filename}
      // FIXME: на прокси не добавлен эндпоинт в документацию
      href={getFile.data?.file_id ? `/api/point/1/files/${getFile.data.file_id}/binary` : undefined}
      icon={<DownloadIcon />}
      kind="primary"
      title={t('title')}
      variant="flat"
      {...testid(dataTestId, fileId)}
      {...props}
    />
  );
}

DownloadFileIconButton.displayName = displayName;

export { DownloadFileIconButton };
